function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import ConfigProvider from '../config-provider';
import Tab from './tab';
export default ConfigProvider.config(Tab, {
  transform:
  /* istanbul ignore next */
  function transform(props, deprecated) {
    if ('type' in props) {
      deprecated('type', 'shape', 'Tab');

      var _props = props,
          type = _props.type,
          others = _objectWithoutProperties(_props, ["type"]);

      props = _objectSpread({
        shape: type
      }, others);
    }

    if ('resDirection' in props) {
      var _props2 = props,
          resDirection = _props2.resDirection,
          _others = _objectWithoutProperties(_props2, ["resDirection"]);

      var excessMode;

      if (resDirection === 'horizontal') {
        deprecated('resDirection=horizontal', 'excessMode=slide', 'Tab');
        excessMode = 'slide';
      } else if (resDirection === 'vertical') {
        deprecated('resDirection=vertical', 'excessMode=dropdown', 'Tab');
        excessMode = 'dropdown';
      }

      props = _objectSpread({
        excessMode: excessMode
      }, _others);
    }

    if ('tabBarExtraContent' in props) {
      deprecated('tabBarExtraContent', 'extra', 'Tab');

      var _props3 = props,
          tabBarExtraContent = _props3.tabBarExtraContent,
          _others2 = _objectWithoutProperties(_props3, ["tabBarExtraContent"]);

      props = _objectSpread({
        extra: tabBarExtraContent
      }, _others2);
    }

    return props;
  }
});